import Vue from "vue";
import {CURRENCIES} from "@/modules/common/constants/currency";

const amountWithCurrency = Vue.filter("amountWithCurrency", (value, currency, locale, fixedPointLength = null, additionalOptions = {}) => {
  if (locale === 'keys' || locale === 'pseudo') {
    locale = 'en'
  }
  if(fixedPointLength !== null) {
    value = parseFloat(value).toFixed(fixedPointLength)
  }
  return Intl.NumberFormat(locale, { style: 'currency', currency: currency, ...additionalOptions }).format(value)
});

const toCurrency = Vue.filter("currency", value => {
  if(!value) {
    return value
  }
  return CURRENCIES[value].symbol_native;
});

const toCurrencyName = Vue.filter("currencyName", value => {
  return CURRENCIES[value].name;
});

export default {
  amountWithCurrency,
  toCurrency,
  toCurrencyName,
}
